import React from 'react';
import {useSelector} from "react-redux";
import {Col, Row} from "react-bootstrap";
import Input from "../../../common/Input";
import Dropdown from "../../../primer/Dropdown";
import {
    colorMapping,
    decimalToHourMinutesFormat,
    delayReasonOptions,
    getWorkType,
    movementTypeOptions
} from "./Components/constants";
import HourPicker from "../../../primer/HourPicker";
import moment from "moment/moment";
import TextArea from "../../../common/TextArea";
import Alert from "react-bootstrap/Alert";
import LogTable from "../../../primer/LogTable";
import useErganiInstallationOptions from "../../../../hooks/useErganiInstallationOptions";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import {useTranslation} from "../../../../hooks/useTranslation";

const EditWorkMovement = () => {
    const {t} = useTranslation();
    const workMovement = useSelector((state) => state.PAYROLL.editWorkMovement);

    const installationOptions = useErganiInstallationOptions(false);

    const isWorkMovementDelayed = () => {
        let diff = moment().diff(moment(workMovement.date).set({hour: Number(String(workMovement.time).split(":")[0]), minute: Number(String(workMovement.time).split(":")[1])}), "minute")
        diff = Math.abs(diff);

        return diff > 15;
    }

    const dailyProgram = !isEmpty(workMovement.employeeProgramData) ? Array.isArray(workMovement.employeeProgramData) ? workMovement.employeeProgramData : [workMovement.employeeProgramData] : null;

    return (
        <React.Fragment>
            <Alert variant={"secondary"}>
                {workMovement?.simulation === true ? (
                    <span>Η κίνηση δεν είναι επεξεργάσιμη. Έχει πραγματοποιηθεί μέσω εξομοίωσης.</span>
                ) : (
                    <span>Η κίνηση δεν είναι επεξεργάσιμη επειδή έχει σταλθεί στην Εργάνη.</span>
                )}
            </Alert>
            <Row className={"mb-3"}>
                <Col md={4}>
                    <Input
                        label={t("General.employee")}
                        disabled={true}
                        value={String(workMovement.employeeName).replace(/\|/g, " ")}
                    />
                    <Dropdown
                        name={"installationMasterId"}
                        label={t("General.installation")}
                        options={installationOptions}
                        defaultValue={installationOptions.find((el) => el.value === workMovement.installationMasterId)}
                        key={Math.random()}
                        disabled={true}
                        className={"mt-2"}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name={"date"}
                        label={"Ημερομηνία"}
                        value={moment(workMovement.date).format("DD-MM-YYYY")}
                        disabled={true}
                    />
                </Col>
                {dailyProgram && dailyProgram.map((dc) => (
                    <Col md={5}>
                        <div style={{
                            position: "relative",
                            display: "inline-block",
                            height: "100%",
                            width: `${(100 / dailyProgram.length) - 2}%`,
                            backgroundColor: colorMapping[dc?.workType],
                            margin: "4px",
                            padding: "4px",
                            borderRadius: "8px",
                            textAlign: "center"
                        }}>
                            {getWorkType(dc)}<br/>
                            {dc?.allDay ? (
                                <React.Fragment>
                                    Όλη μέρα<br/>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    {decimalToHourMinutesFormat(dc.hourFrom)} - {decimalToHourMinutesFormat(dc.hourTo)}<br/>
                                </React.Fragment>
                            )}
                            Εγκατάσταση: {dc.installationMasterId}
                        </div>
                    </Col>
                ))}
            </Row>
            {Object.keys(workMovement.employeeProgramData).length > 0 && (
                <React.Fragment>
                    <hr className={"mt-3 mb-2"}/>
                    <Row className={"mb-3"}>
                        <Col md={3}>
                            <Dropdown
                                name={"movementType"}
                                label={"Τύπος Κίνησης"}
                                options={movementTypeOptions}
                                key={Math.random()}
                                disabled={true}
                                defaultValue={movementTypeOptions.find((el) => el.value === workMovement.movementType)}
                            />
                        </Col>
                        <Col md={2}>
                            <HourPicker
                                label={"Ώρα"}
                                name={"time"}
                                timeIntervals={3}
                                selected={moment(workMovement.time, "HH:mm").toDate()}
                                disabled={true}
                            />
                        </Col>
                        {isWorkMovementDelayed() && (
                            <Col md={3}>
                                <Dropdown
                                    name={"delayReason"}
                                    label={"Λόγος καθυστέρησης"}
                                    options={delayReasonOptions}
                                    key={Math.random()}
                                    disabled={true}
                                    defaultValue={delayReasonOptions.find((el) => el.value === workMovement.delayReason)}
                                />
                            </Col>
                        )}
                    </Row>
                    <Row>
                        <Col md={12}>
                            <TextArea
                                name={"notes"}
                                label={t("General.notes")}
                                rows={4}
                                value={workMovement.notes}
                                disabled={true}
                            />
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export const WorkMovementEditLog = () => {
    const {t} = useTranslation();
    const workMovement = useSelector((state) => state.PAYROLL.editWorkMovement);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.workMovementLog')}</i></div>
            <LogTable itemId={workMovement._id}/>
        </React.Fragment>
    )
}

export default EditWorkMovement
